import { render, staticRenderFns } from "./Device-from.vue?vue&type=template&id=479c902f&scoped=true&"
import script from "./Device-from.vue?vue&type=script&lang=js&"
export * from "./Device-from.vue?vue&type=script&lang=js&"
import style0 from "./Device-from.vue?vue&type=style&index=0&id=479c902f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "479c902f",
  null
  
)

export default component.exports